import {
  GetInstallmentFeesRequest,
  GetInstallmentFeesResponse,
} from '@aaa-ncnu-ie/mypolicy-api-billing';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import axios from './axios';

export const getInstallmentFees = async ({
  productCode,
  riskState,
  effectiveDate,
  isAutoPayEnrolled,
  policyFormCode,
}: GetInstallmentFeesRequest) => {
  if (!productCode || !riskState) {
    return Promise.reject(new Error('Missing required parameters'));
  }

  const { data } = await axios.get<GetInstallmentFeesResponse>(
    `${import.meta.env.VITE_MYPOLICY_BILLING_API_URL}/v1/fees/installment-fees`,
    {
      params: {
        productCode,
        riskState,
        effectiveDate,
        isAutoPayEnrolled,
        policyFormCode,
      },
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
    }
  );

  return data;
};

export const useInstallmentsFeesQuery = ({
  productCode,
  riskState,
  effectiveDate,
  isAutoPayEnrolled,
  policyFormCode,
}: GetInstallmentFeesRequest) =>
  useQuery({
    queryKey: [
      'installmentFees',
      productCode,
      riskState,
      effectiveDate,
      isAutoPayEnrolled,
      policyFormCode,
    ],
    queryFn: () =>
      getInstallmentFees({
        productCode,
        riskState,
        effectiveDate,
        isAutoPayEnrolled,
        policyFormCode,
      }),
    enabled: !!productCode && !!riskState,
    staleTime: 1000 * 60 * 10,
  });
